const translations = {
  title: 'Webhook',
  modalTitle: 'Criar novo Webhook',
  name: 'Nome',
  availableUses: 'Usos disponíveis',
  enabled: 'Ativado',
  remainingUse: 'Uso restante',
  remainingUses: '{{count}} chamada',
  remainingUses_plural: '{{count}} chamadas',
  noLimit: 'Sem limite',
  url: 'URL',
  conditions: 'Condições',
  payload: 'Payload',
  details: 'Detalhes',
  calls: 'Chamadas',
  status: 'Status',
  creationDate: 'Data de criação',
  moreDetails: 'Mais detalhes',
  lessDetails: 'Menos detalhes',
  statusCalled: 'Chamado',
  statusError: 'Erro',
  statusSuccess: 'Sucesso',
  'stays.name': 'Nome*',
  'stays.maxRequests': 'Máximo de requisição possível',
  'stays.cancelReason': 'Motivo do cancelamento*',
  'stays.questionnaire': 'Questionário*',
  'stays.editTitle': 'Editar webhook stays',
  'stays.newTitle': 'Novo webhook stays',
  'stays.widgetName': 'Integração com Stays',
  'stays.widgetDescription': 'Criar integração com sistemas Stays',
  'stays.widgetCategory': 'Comunicação Externa'
}

export default translations
